import { inject } from "@angular/core";
import type { CanActivateFn } from "@angular/router";
import { Router } from "@angular/router";
import { TranslocoService } from "@jsverse/transloco";

export const homeRedirectGuard: CanActivateFn = () => {
    const router = inject(Router);
    const translocoService = inject(TranslocoService);

    const currentLang = translocoService.getActiveLang();

    router.navigate([currentLang]);

    return false;
};
